"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyAssignmentHistorySchema () {
        return CompetencyAssignmentHistorySchema;
    },
    get CompetencyHistoryEventTypeSchema () {
        return CompetencyHistoryEventTypeSchema;
    },
    get CompetencyLevelChangeSourceSchema () {
        return CompetencyLevelChangeSourceSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const _constants = require("./constants");
const CompetencyHistoryEventTypeSchema = _zod.z.enum([
    "level_update",
    "expected_level_update",
    "role_assignment",
    "role_unassignment",
    "role_competency_removal",
    "company_wide_assignment"
]);
const CompetencyLevelChangeSourceSchema = _zod.z.enum([
    "manual",
    "review"
]);
const levelValue = _zod.z.number().int().min(1).max(_constants.MAX_COMPETENCY_LEVELS).nullable();
const historyBase = _base.BaseDocument.extend({
    competency_assignment_id: _zod.z.instanceof(_bson.ObjectId),
    competency_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    effective_date: _zod.z.instanceof(Date),
    created: _useractionrecord.UserActionRecord
});
const CompetencyAssignmentHistorySchema = _zod.z.discriminatedUnion("event_type", [
    historyBase.extend({
        event_type: _zod.z.literal("level_update"),
        previous_level: levelValue,
        new_level: levelValue,
        source: CompetencyLevelChangeSourceSchema,
        role_id: _zod.z.null()
    }),
    historyBase.extend({
        event_type: _zod.z.literal("expected_level_update"),
        previous_level: levelValue,
        new_level: levelValue,
        source: _zod.z.null(),
        role_id: _zod.z.null()
    }),
    historyBase.extend({
        event_type: _zod.z.literal("role_assignment"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        role_id: _zod.z.instanceof(_bson.ObjectId)
    }),
    historyBase.extend({
        // The assignment was archived because the user left the role (role switch, role
        // cleared, or removed from the role's membership). role_id = the role they left.
        event_type: _zod.z.literal("role_unassignment"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        role_id: _zod.z.instanceof(_bson.ObjectId)
    }),
    historyBase.extend({
        // The assignment was archived because an admin removed the competency from the role's
        // definition. role_id = the role it was removed from.
        event_type: _zod.z.literal("role_competency_removal"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        role_id: _zod.z.instanceof(_bson.ObjectId)
    }),
    historyBase.extend({
        event_type: _zod.z.literal("company_wide_assignment"),
        previous_level: _zod.z.null(),
        new_level: _zod.z.null(),
        source: _zod.z.null(),
        role_id: _zod.z.null()
    })
]);
